<div class="tw-flex-col">
  <span bitTypography="h6" class="tw-flex tw-text-main">{{ title | i18n }}</span>
  <div class="tw-flex tw-items-baseline tw-gap-2">
    <span bitTypography="h3">{{ cardMetrics | i18n: value }}</span>
  </div>
  <div class="tw-flex tw-items-baseline tw-gap-2">
    <span bitTypography="body2">{{ metricDescription | i18n }}</span>
  </div>
</div>
